import { z } from 'zod';
import { TIPOS_TECNICO } from './tecnicos.js';
/**
 * Importação em massa de pessoas por planilha, em dois tempos: **analisar** e **confirmar**.
 *
 * O primeiro passo não grava nada. Ele lê o arquivo, confere linha por linha e devolve o
 * que aconteceria — é o que permite descobrir um e-mail com domínio errado antes de criar
 * a conta, e não no dia em que a pessoa não consegue entrar.
 *
 * A senha nunca volta para a tela: ela fica guardada no servidor entre os dois passos e a
 * análise devolve só se é aceitável. Mandar de volta o que veio da planilha seria espalhar
 * a senha por mais um lugar sem necessidade.
 */
export const COLUNAS_IMPORTACAO = ['Nome', 'Email', 'Senha'];
/** Escolha obrigatória por pessoa: sem setor e perfil, o usuário não saberia onde atender. */
export const itemImportacaoUsuarioSchema = z.object({
    linha: z.number().int().positive(),
    setorId: z.string().uuid('Escolha o setor'),
    perfilId: z.string().uuid('Escolha o perfil'),
    papel: z.enum(['atendente', 'supervisor']),
});
export const confirmarImportacaoUsuariosSchema = z.object({
    importacaoId: z.string().min(1),
    itens: z.array(itemImportacaoUsuarioSchema).min(1, 'Nenhuma linha para importar'),
});
/**
 * Técnico não tem setor nem perfil, mas tem time: campo ou rede.
 *
 * Escolha por linha, como setor e perfil do usuário, e pela mesma razão (decisão de
 * 28/09): um padrão aplicado a todos esconde justamente quem é exceção — e aqui a exceção
 * cairia na fila errada, descobrindo isso só no dia em que precisasse do NOC.
 */
export const itemImportacaoTecnicoSchema = z.object({
    linha: z.number().int().positive(),
    tipo: z.enum(TIPOS_TECNICO, { message: 'Escolha se é de campo ou de rede' }),
});
export const confirmarImportacaoTecnicosSchema = z.object({
    importacaoId: z.string().min(1),
    itens: z.array(itemImportacaoTecnicoSchema).min(1, 'Nenhuma linha para importar'),
});
//# sourceMappingURL=importacao.js.map